import React from 'react';
import { motion } from 'framer-motion';
import styles from './Hero.module.css';
import myLogo from '../../aryannlogo.png';


function Hero() {
    // Animation variants for text and Enigma
    const textVariant = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
    };

    const enigmaVariant = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { opacity: 1, scale: 1 },
    };

    return (
        <div>
            <header className={`h-full lg:h-dvh bg-gray-100 dark:bg-gray-900 ${styles.pattern}`}>
                <div className="container px-6 mx-auto h-[100%]">
                    <motion.nav
                        className="flex flex-col py-6 sm:flex-row sm:justify-between sm:items-center"
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <a href="#contact">
                            <img className="w-auto h-6 sm:h-7" src={myLogo} alt="" />
                        </a>

                        <div className="flex items-center mt-2 -mx-2 sm:mt-0">
                            <a href="#experience" className="px-3 py-1 text-sm font-semibold text-gray-800 dark:text-white transition-colors duration-300 transform border-2 border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700">
                                Experience
                            </a>
                            <a href="#blog" className="px-3 py-2 mx-2 text-sm font-semibold text-white bg-gray-800 dark:bg-black transition-colors duration-300 transform rounded-md hover:bg-gray-700 dark:hover:bg-gray-800">
                                Blog
                            </a>
                        </div>
                    </motion.nav>

                    <div className="flex flex-col items-center py-6 lg:h-[80%] lg:flex-row">
                        <motion.div
                            className="lg:w-1/2"
                            variants={textVariant}
                            initial="hidden"
                            animate="visible"
                            transition={{ duration: 0.8, delay: 0.2 }}
                        >
                            <p className="text-2xl font-semibold lg:text-2xl text-gray-600 dark:text-gray-400 flex items-center gap-3">
                                <svg
                                    className="w-6 h-6 text-gray-600 dark:text-gray-400 inline-block"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 18 14"
                                >
                                    <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
                                </svg>
                                Crafting Digital Experiences Innovatively.
                            </p>

                            <h2 className="mt-4 text-5xl font-semibold text-gray-800 dark:text-gray-100 lg:text-6xl">
                                Aryann <span className="text-blue-600 dark:text-blue-400">Dwivedi.</span>
                            </h2>
                            <p className="mt-2 text-lg text-gray-600 dark:text-gray-400">
                                <strong>Core @Circuiverse</strong>
                            </p>
                        </motion.div>
                        <motion.div
                            className="lg:w-1/2"
                            variants={enigmaVariant}
                            initial="hidden"
                            animate="visible"
                            transition={{ duration: 0.8, delay: 0.4 }}
                        >
                            
                        </motion.div>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default Hero;